module.exports = __webpack_public_path__ + "static/media/personal_sandbox.9d0fdc43.png";